import { useEffect } from "react";

const SupportChatLoader = ({ showWidget = false }) => {
  useEffect(() => {
    // Script zaten bir kez yüklendi mi kontrol etmek istersen buraya kontrol eklenebilir
    const script = document.createElement("script");
    script.src = "//fw-cdn.com/12621117/5007796.js";
    script.setAttribute("chat", "true");
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }

      // Widget DOM'u da temizlenmek istenirse:
      const containers = document.querySelectorAll('[id^="fc-"], .fc-widget-container, .fc-widget');
      containers.forEach(el => el.remove());
    };
  }, []);

  useEffect(() => {
    const toggleWidget = () => {
      if (window.fcWidget) {
        if (showWidget) {
          window.fcWidget.show();
        } else {
          window.fcWidget.hide();
        }
      }
    };

    // Script yüklendikten sonra fcWidget biraz gecikebileceği için küçük bir delay veriyoruz
    const timeout = setTimeout(toggleWidget, 1000);

    return () => clearTimeout(timeout);
  }, [showWidget]);

  return null;
};

export default SupportChatLoader;
